export default __webpack_public_path__ + "assets/front/scss/user-authentication.761a98f63d731c5a9e75dc20757be638.css";